<section class="hero-container">
  <section
    class="hero"
    [ngClass]="{
      'hero--short': shortHero,
      'hero--full': fullHero,
    }">
    @if ({ indexHero: indexHero$ | async }; as context) {
      @defer (on idle) {
        @for (_ of backGroundImages; track _; let i = $index; let even = $even) {
          <picture
            class="hero__picture"
            [ngClass]="{
              'hero__picture--hidden': i !== context.indexHero,
            }">
            @if (resolutionsKeys(); as resolutions) {
              @for (res of resolutions | slice: 0 : resolutions.length - 1; track res) {
                <source
                  media="(max-width: {{ res }}px)"
                  [srcset]="$any(backGroundImages?.[i])?.[res]" />
              }
              <img
                loading="eager"
                fetchpriority="low"
                class="hero__img"
                alt="hero section image"
                [src]="$any(backGroundImages?.[i])?.[resolutions[resolutions.length - 1]]"
                (load)="i === 0 && onImageLoad()" />
            }
          </picture>
        }
      } @placeholder (minimum 200ms) {
        <picture
          id="blurred"
          class="hero__picture">
          <img
            loading="eager"
            fetchpriority="high"
            alt="hero section image"
            [src]="thumb ?? 'https://media.sharry.land/app/loader-placeholder.gif'"
            (load)="thumbLoaded = true" />
        </picture>
      }
      <div
        class="hero__titles-container"
        [ngClass]="{ 'hero__titles-container--trip': component === 'trip' }">
        @if (!!$any(backGroundImages?.[context.indexHero])?.title) {
          <h1
            sharryViewport="fade-in-1"
            [uuid]="'hero__h1.' + component"
            [ngClass]="{ black: h1Black === true }"
            [innerHTML]="$any(backGroundImages?.[context.indexHero])?.title | i18next"></h1>
        } @else {
          <h1
            sharryViewport="fade-in-1"
            [uuid]="'hero__h1.' + component"
            [ngClass]="{ black: h1Black === true }"
            [innerHTML]="$any(backGroundImages?.[context.indexHero])?.title$ | async | i18next"></h1>
        }
        @if ($any(backGroundImages?.[context.indexHero])?.subtitle.length) {
          <h2
            sharryViewport="fade-in-2"
            [uuid]="'hero__h2.' + component"
            [innerHTML]="$any(backGroundImages?.[context.indexHero])?.subtitle | i18next"></h2>
        }
        @if ((userService.user$ | async) === null && showSignUp) {
          <a
            mat-flat-button
            color="rainbow"
            class="sharry-xl rounded"
            sharryViewport="fade-in-2"
            [routerLink]="[]"
            [queryParams]="{ signup: true }">
            {{ 'sign-up.title' | i18next }}
          </a>
        }
      </div>
    }
  </section>
</section>
